import {INITIAL_STATE} from './states';

export const df = (state = INITIAL_STATE, action) => {
    const {type, payload} = action;
    switch (type) {
        case 'SET_DISCUSSIONS':
            return {
                ...state,
                discussions: payload,
            };
        case 'SET_ACTIVE_DISCUSSION':
            return {
                ...state,
                activeDiscussion: state.discussions[payload],
            };
        case 'SET_COMMENTS':
            return {
                ...state,
                activeDiscussion: {
                    ...state.activeDiscussion,
                    comments: payload,
                },
            };
        case 'SET_PARTICIPANTS':
            return {
                ...state,
                activeDiscussion: {
                    ...state.activeDiscussion,
                    participants: payload,
                },
            };
        case 'UPDATE_COMMENT_LIKE':
            return {
                ...state,
                activeDiscussion: {
                    ...state.activeDiscussion,
                    comments: {
                        ...state.activeDiscussion.comments,
                        [payload.msgId]: {
                            ...state.activeDiscussion.comments[payload.msgId],
                            userLike: payload.likeDislike,
                            totalLike: payload.likes,
                            totalDisLike: payload.dislikes,
                        },
                    },
                },
            };
        case 'EDIT_COMMENT_MESSAGE':
            return {
                ...state,
                activeDiscussion: {
                    ...state.activeDiscussion,
                    comments: {
                        ...state.activeDiscussion.comments,
                        [payload.msgId]: {
                            ...state.activeDiscussion.comments[payload.msgId],
                            message: payload.message,
                        },
                    },
                },
            };
        case 'UPDATE_REPLY_LIKE':
            return {
                ...state,
                activeDiscussion: {
                    ...state.activeDiscussion,
                    comments: {
                        ...state.activeDiscussion.comments,
                        [payload.msgId]: {
                            ...state.activeDiscussion.comments[payload.msgId],
                            replies: state.activeDiscussion.comments[
                                payload.msgId
                            ].replies.map((r) => {
                                if (r.msgId === payload.replyId) {
                                    return {
                                        ...r,
                                        userLike: payload.likeDislike,
                                        totalLike: payload.likes,
                                        totalDisLike: payload.dislikes,
                                    };
                                }
                                return r;
                            }),
                        },
                    },
                },
            };
        case 'EDIT_REPLY_MESSAGE':
            return {
                ...state,
                activeDiscussion: {
                    ...state.activeDiscussion,
                    comments: {
                        ...state.activeDiscussion.comments,
                        [payload.msgId]: {
                            ...state.activeDiscussion.comments[payload.msgId],
                            replies: state.activeDiscussion.comments[
                                payload.msgId
                            ].replies.map((r) => {
                                if (r.msgId === payload.replyId) {
                                    return {
                                        ...r,
                                        message: payload.message,
                                    };
                                }
                                return r;
                            }),
                        },
                    },
                },
            };
        default:
            return state;
    }
};
